<template>
  <div id="display_none" style="width: 100%;">
    <div
      class="btn-wrap"
      :class="{
        'is-showmore__height': isShowMore,
        'is-showbtn__height':
          isShowMore && $refs.opinionText && $refs.opinionText.opinion
      }"
      v-if="!isShowOperation"
    >
      <div
        ref="btnRegion"
        class="btn_region  no-print"
        v-if="isShowApprovalArea"
      >
        <div class="btn_region_in" :style="'width:' + btn_region_in_w">
          <div style="padding-left: 20px;padding-right: 20px;">
            <table style="width:100%;">
              <tbody>
                <tr
                  v-if="type != 'done' && type != 'request' && type != 'read'"
                >
                  <!-- <td class="region">审批按钮：</td> -->
                  <td
                    v-if="status != 'COMMU' && status != 'TRANSFORMEDINQU'"
                    class="action-group action-btn"
                  >
                    <div class="action-btn">
                      <!--自由跳转-->
                      <el-row class="action-btn">
                        <el-button
                          :type="'primary'"
                          v-if="$route.query.type === 'free'"
                          :disabled="disabled"
                          @click="submitRevoke('free')"
                          >自由跳转</el-button
                        >
                      </el-row>
                    </div>
                    <div
                      class="action-btn"
                      v-for="(item, index) in rowsBtn"
                      :key="index"
                    >
                      <!-- 无强制签收配置  且有签收按钮-->
                      <div
                        v-if="
                          item.isLock == false && (canLock == 3 || canLock == 1)
                        "
                      >
                        <el-row class="action-btn" v-if="item.alias == 'agree'">
                          <!-- <el-radio v-model="btnAilas" label="agree">{{item.name}}</el-radio> -->
                          <el-button
                            type="primary"
                            @click="submitRevoke('agree')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'oppose'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="oppose">{{item.name}}</el-radio> -->
                          <el-button
                            type="danger"
                            @click="submitRevoke('oppose')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'agreeTrans'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="agreeTrans">{{item.name}}</el-radio> -->
                          <el-button
                            type="primary"
                            @click="submitRevoke('agreeTrans')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'opposeTrans'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="opposeTrans">{{item.name}}</el-radio> -->
                          <el-button
                            type="danger"
                            @click="submitRevoke('opposeTrans')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'lockUnlock' && canLock == 1"
                        >
                          <!-- <el-radio v-model="btnAilas" label="lockUnlock">签收</el-radio> -->
                          <el-button
                            type="default"
                            @click="submitRevoke('lockUnlock')"
                            >签收</el-button
                          >
                        </el-row>
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'reject'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="reject">{{item.name}}</el-radio> -->
                          <el-button
                            type="danger"
                            @click="submitRevoke('reject')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'endProcess'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="endProcess">{{item.name}}</el-radio> -->
                          <el-button
                            type="default"
                            @click="submitRevoke('endProcess')"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'saveDraft'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="saveDraft">{{item.name}}</el-radio> -->
                          <el-button
                            type="default"
                            @click="submitRevoke('saveDraft')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <el-row class="action-btn" v-if="item.alias == 'inqu'">
                          <!-- <el-radio v-model="btnAilas" label="inqu">{{item.name}}</el-radio> -->
                          <el-button
                            type="default"
                            @click="submitRevoke('inqu')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <!-- <el-row class="action-btn" v-if="item.alias=='addSign'">
                        <el-button
                          type="default"
                          @click="submitRevoke('addSign')"
                          :disabled="disabled"
                        >{{item.name}}</el-button>
                      </el-row> -->

                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'delegate'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="delegate">{{item.name}}</el-radio> -->
                          <el-button
                            type="default"
                            @click="submitRevoke('delegate')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'startTrans'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="startTrans">{{item.name}}</el-radio> -->
                          <el-button
                            type="default"
                            @click="submitRevoke('startTrans')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <!-- <el-row class="action-btn" v-if="item.alias=='instanceTrans'">
                              <el-button type="default" @click="taskToCopyTo">{{item.name}}</el-button>
                      </el-row>-->
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'taskDelay'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="taskDelay">{{item.name}}</el-radio> -->
                          <el-button
                            type="default"
                            @click="submitRevoke('taskDelay')"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <!-- <el-row class="action-btn" v-if="item.alias=='lockUnlock' &&  canLock==3">
                              <el-button type="default" @click="lockUnlock">取消签收</el-button>
                      </el-row>-->
                      </div>
                      <!-- 有强制签收配置  且无签收-->
                      <div v-else-if="item.isLock == true && canLock == 1">
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'lockUnlock' && canLock == 1"
                        >
                          <!-- <el-radio v-model="btnAilas" label="lockUnlock">签收</el-radio> -->
                          <el-button
                            type="default"
                            @click="submitRevoke('lockUnlock')"
                            >签收</el-button
                          >
                        </el-row>
                      </div>
                      <!-- 有强制签收配置  且已签收-->
                      <div v-else-if="item.isLock == true && canLock == 3">
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'saveDraft'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="saveDraft">{{item.name}}</el-radio> -->
                          <el-button
                            type="default"
                            @click="submitRevoke('saveDraft')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <el-row class="action-btn" v-if="item.alias == 'agree'">
                          <!-- <el-radio v-model="btnAilas" label="agree">{{item.name}}</el-radio> -->
                          <el-button
                            type="primary"
                            @click="submitRevoke('agree')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'agreeTrans'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="agreeTrans">{{item.name}}</el-radio> -->
                          <el-button
                            type="primary"
                            @click="submitRevoke('agreeTrans')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'opposeTrans'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="opposeTrans">{{item.name}}</el-radio> -->
                          <el-button
                            type="danger"
                            @click="submitRevoke('opposeTrans')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <el-row class="action-btn" v-if="item.alias == 'inqu'">
                          <!-- <el-radio v-model="btnAilas" label="inqu">{{item.name}}</el-radio> -->
                          <el-button
                            type="default"
                            @click="submitRevoke('inqu')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <!-- <el-row class="action-btn" v-if="item.alias=='addSign'">
                        <el-button
                          type="default"
                          @click="submitRevoke('addSign')"
                          :disabled="disabled"
                        >{{item.name}}</el-button>
                      </el-row> -->
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'delegate'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="delegate">{{item.name}}</el-radio> -->
                          <el-button
                            type="default"
                            @click="submitRevoke('delegate')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'startTrans'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="startTrans">{{item.name}}</el-radio> -->
                          <el-button
                            type="default"
                            @click="submitRevoke('startTrans')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <!-- <el-row class="action-btn" v-if="item.alias=='instanceTrans'">
                              <el-button type="default" @click="taskToCopyTo">{{item.name}}</el-button>
                      </el-row>-->
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'taskDelay'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="taskDelay">{{item.name}}</el-radio> -->
                          <el-button
                            type="default"
                            @click="submitRevoke('taskDelay')"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'reject'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="reject">{{item.name}}</el-radio> -->
                          <el-button
                            type="danger"
                            @click="submitRevoke('reject')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'endProcess'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="endProcess">{{item.name}}</el-radio> -->
                          <el-button
                            type="default"
                            @click="submitRevoke('endProcess')"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'oppose'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="oppose">{{item.name}}</el-radio> -->
                          <el-button
                            type="danger"
                            @click="submitRevoke('oppose')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <!-- <el-row class="action-btn" v-if="item.alias=='lockUnlock' &&  canLock==3">
                              <el-button type="default" @click="lockUnlock">取消签收</el-button>
                      </el-row>-->
                      </div>
                      <!-- 正常审批-->
                      <div v-else>
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'saveDraft'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="saveDraft">{{item.name}}</el-radio> -->
                          <el-button
                            type="default"
                            @click="submitRevoke('saveDraft')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <el-row class="action-btn" v-if="item.alias == 'agree'">
                          <!-- <el-radio v-model="btnAilas" label="agree">{{item.name}}</el-radio> -->
                          <el-button
                            type="primary"
                            @click="submitRevoke('agree')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'agreeTrans'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="agreeTrans">{{item.name}}</el-radio> -->
                          <el-button
                            type="primary"
                            @click="submitRevoke('agreeTrans')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'opposeTrans'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="opposeTrans">{{item.name}}</el-radio> -->
                          <el-button
                            type="danger"
                            @click="submitRevoke('opposeTrans')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <el-row class="action-btn" v-if="item.alias == 'inqu'">
                          <!-- <el-radio v-model="btnAilas" label="inqu">{{item.name}}</el-radio> -->
                          <el-button
                            type="default"
                            @click="submitRevoke('inqu')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <!-- <el-row class="action-btn" v-if="item.alias=='addSign'">
                        <el-button
                          type="default"
                          @click="submitRevoke('addSign')"
                          :disabled="disabled"
                        >{{item.name}}</el-button>
                      </el-row> -->
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'addSignMore'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="addSign">{{item.name}}</el-radio> -->
                          <el-button
                            type="default"
                            @click="submitRevoke('addSignMore')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'delegate'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="delegate">{{item.name}}</el-radio> -->
                          <el-button
                            type="default"
                            @click="submitRevoke('delegate')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'startTrans'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="startTrans">{{item.name}}</el-radio> -->
                          <el-button
                            type="default"
                            @click="submitRevoke('startTrans')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <!-- <el-row class="action-btn" v-if="item.alias=='instanceTrans'">
                              <el-button type="default" @click="taskToCopyTo">{{item.name}}</el-button>
                      </el-row>-->
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'taskDelay'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="taskDelay">{{item.name}}</el-radio> -->
                          <el-button
                            type="default"
                            @click="submitRevoke('taskDelay')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'reject'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="reject">{{item.name}}</el-radio> -->
                          <el-button
                            type="danger"
                            @click="submitRevoke('reject')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'endProcess'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="endProcess">{{item.name}}</el-radio> -->
                          <el-button
                            type="default"
                            @click="submitRevoke('endProcess')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'oppose'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="oppose">{{item.name}}</el-radio> -->
                          <el-button
                            type="danger"
                            @click="submitRevoke('oppose')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'approveLine'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="approveLine">{{item.name}}</el-radio> -->
                          <el-button
                            type="default"
                            @click="submitRevoke('approveLine')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'signSequence'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="signSequence">{{item.name}}</el-radio> -->
                          <el-button
                            type="default"
                            @click="submitRevoke('signSequence')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                        <el-row
                          class="action-btn"
                          v-if="item.alias == 'signLine'"
                        >
                          <!-- <el-radio v-model="btnAilas" label="signLine">{{item.name}}</el-radio> -->
                          <el-button
                            type="default"
                            @click="submitRevoke('signLine')"
                            :disabled="disabled"
                            >{{ item.name }}</el-button
                          >
                        </el-row>
                      </div>
                    </div>
                    <el-row class="action-btn">
                      <el-button
                        type="default"
                        @click="submitRevoke('taskClose')"
                        >关闭</el-button
                      >
                    </el-row>
                  </td>
                  <td
                    width="600"
                    v-if="status == 'TRANSFORMEDINQU'"
                    class="action-group action-btn"
                  >
                    <!-- <el-radio v-model="btnAilas" label="taskToInquReply">征询回复</el-radio> -->
                    <el-button
                      type="primary"
                      @click="submitRevoke('taskToInquReply')"
                      >征询回复</el-button
                    >
                    <el-button type="default" @click="submitRevoke('taskClose')"
                      >关闭</el-button
                    >
                  </td>
                  <td
                    width="600"
                    v-if="status == 'COMMU'"
                    class="action-group action-btn"
                  >
                    <!-- <el-radio v-model="btnAilas" label="commuFeedBack">沟通反馈</el-radio> -->
                    <el-button
                      type="primary"
                      @click="submitRevoke('commuFeedBack')"
                      >沟通反馈</el-button
                    >
                    <el-button type="default" @click="submitRevoke('taskClose')"
                      >关闭</el-button
                    >
                  </td>
                  <td style=" float: right;margin-top: 1px">
                    <el-button type="primary" @click="showMoreOperations()"
                      >更多操作</el-button
                    >
                  </td>
                </tr>
                <tr v-if="type == 'done' || type == 'request'">
                  <!-- <td class="region">审批按钮：</td> -->
                  <td width="600" class="action-group action-btn">
                    <!-- <el-radio v-model="btnAilas" label="handleRevoke">撤回</el-radio> -->
                    <el-button
                      type="danger"
                      @click="submitRevoke('handleRevoke')"
                      v-if="type != 'request'"
                      >撤回</el-button
                    >
                    <el-button type="default" @click="submitRevoke('taskClose')"
                      >关闭</el-button
                    >
                  </td>
                  <td style=" float: right;margin-top: 1px">
                    <el-button
                      type="primary"
                      @click="showMoreOperations()"
                      v-if="type != 'request'"
                      >更多操作</el-button
                    >
                  </td>
                </tr>
                <tr v-if="type == 'read'">
                  <!-- <td class="region">审批按钮：</td> -->
                  <td width="600" class="action-group action-btn">
                    <!-- <el-radio v-model="btnAilas" label="handleRead">回复</el-radio> -->
                    <el-button
                      type="primary"
                      @click="submitRevoke('handleRead')"
                      >回复</el-button
                    >
                    <el-button type="default" @click="submitRevoke('taskClose')"
                      >关闭</el-button
                    >
                  </td>
                  <td style=" float: right;margin-top: 1px">
                    <el-button type="primary" @click="showMoreOperations()"
                      >更多操作</el-button
                    >
                  </td>
                </tr>
                <tr v-show="isShowMore">
                  <!-- <td width="50">审批意见：</td> -->
                  <td width="600">
                    <OpinionText
                      :text="text"
                      ref="opinionText"
                      @getOpinion="getOpinion"
                      class="showmore__content"
                    />
                  </td>
                </tr>
                <tr
                  v-show="
                    isShowMore &&
                      ((isFile && approvalArea) ||
                        type == 'read' ||
                        status == 'COMMU')
                  "
                  v-if="
                    status != 'COPYTO' &&
                      status != 'FOLLOW' &&
                      type != 'done' &&
                      type != 'request' &&
                      (type != undefined || taskId != undefined)
                  "
                >
                  <td>
                    <tr>
                      <td
                        v-if="
                          isShowMore &&
                            $refs.opinionText &&
                            $refs.opinionText.opinion
                        "
                      >
                        <el-button
                          :type="confirmBtnType"
                          @click="confirmBtn"
                          :disabled="disabled"
                          >确定</el-button
                        >
                      </td>
                      <td style="display: none">
                        <FileUpload ref="fileUpload" />
                      </td>
                    </tr>
                  </td>
                </tr>
                <!-- <tr>
                <td></td>
                <td>
                  <el-button
                    type="primary"
                    @click="checkInstStatus(submitRevoke)"
                    size="small"
                    :disabled="disabled"
                  >提 交</el-button>
                </td>
              </tr>-->
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <FormContent
      :tasks="tasks"
      :task_state="task_state"
      :formLoading.sync="disabled"
      ref="formContent"
      :instId="instId"
      :taskId="taskId"
      :type="type"
      :opinionFieldList="opinionFieldList"
      :workOrderNo="workOrderNo"
      :leaderId="leaderId"
      :readId="readId"
      :myReadType="myReadType"
      :readDoneId="readDoneId"
      class="form-content__wrap"
    />
    <!-- <div
      v-show="(iszFile && approvalArea) || (type=='read' || status=='COMMU')"
      v-if="status!='COPYTO' && status!='FOLLOW' && (type!='done' && type!='request') && (type!=undefined || taskId!=undefined)"
    >
      <div class="action-container">
        <span>正文</span>
      </div>
      <div class="action-content">
        <table style="width:100%;">
          <tbody>
            <tr v-if="(type!='done' && type!='request')">
              <td width="50">审批正文：</td>
              <td width="600">
                <FileUpload :limit="1" ref="zfileUpload" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div> -->
    <!-- <div
      v-show="(isFile && approvalArea) || (type=='read' || status=='COMMU')"
      v-if="status!='COPYTO' && status!='FOLLOW' && ((type!='done' && type!='request')) && (type!=undefined || taskId!=undefined)"
    >
      <div class="action-container">
        <span>附件</span>
      </div>
      <div class="action-content">
        <table style="width:100%;">
          <tbody>
            <tr v-if="(type!='done' && type!='request')">
              <td width="50">审批附件：</td>
              <td width="600">
                <FileUpload ref="fileUpload" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div> -->
    <!-- <ProcessRecord
      v-show="(isProcessRecord && approvalArea) || (type=='read' || status=='COMMU' || status=='FOLLOW')"
      :instId="instId"
      :taskId="taskId"
      :referOpinion="referOpinion"
      :nodeType="nodeType"
      :defId="defId"
      :nodeId="nodeId"
    /> -->
    <!-- <div
      v-show="(isApprovalOpinion && approvalArea) || (type=='read' || type=='request' || status=='COMMU')"
      v-if="status!='COPYTO' && status!='FOLLOW' && (type!=undefined || taskId!=undefined)"
    >
      <div class="action-container">
        <span>意见</span>
      </div>
      <div class="action-content">
        <table style="width:100%;">
          <tbody>
            <tr>
              <td width="50">审批意见：</td>
              <td width="600">
                <OpinionText :text="text" ref="opinionText" @getOpinion="getOpinion" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>-->
    <div>
      <el-dialog
        :title="dailogTitle"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-input
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 4 }"
          placeholder="请输入撤回意见"
          v-model="opinion"
        ></el-input>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="saveRevoke" size="small"
            >确 定</el-button
          >
          <el-button @click="exitRevoke" size="small">取 消</el-button>
        </div>
      </el-dialog>
      <!-- 驳回设置 -->
      <TaskToReject
        ref="taskToReject"
        :taskId="taskId"
        :leaderId="leaderId"
        :opinion="text"
      />
      <!-- 转办设置 -->
      <TaskToDelegate ref="taskToDelegate" :taskId="taskId" />
      <!-- 流程抄送 -->
      <TaskToCopyTo ref="taskToCopyTo" :taskId="taskId" :instId="instId" />
      <!-- 征询设置 -->
      <TaskToInqu ref="taskToInqu" :taskId="taskId" />
      <!-- 流程终止 -->
      <TaskToEndProcess ref="taskToEndProcess" :taskId="taskId" />
      <!-- 流转设置 -->
      <TaskToTrans ref="taskToTrans" :taskId="taskId" />
      <!-- 加签设置 -->
      <TaskToAddSign ref="taskToAddSign" :taskId="taskId" />
      <!-- 任务延期 -->
      <TaskToDelay ref="taskToDelay" :taskId="taskId" />
      <!-- 选择路径跳转 -->
      <TaskSelectDestination ref="taskSelectDestination" :taskId="taskId" />
      <!-- 自由跳转 -->
      <TaskSelectDestination2 ref="taskSelectDestination2" :taskId="taskId" />
      <!-- 并行审批设置 -->
      <TaskToApproveLine ref="taskToApproveLine" :taskId="taskId" />
      <!-- 顺序签署设置 -->
      <taskToSignSequence ref="taskToSignSequence" :taskId="taskId" />
      <!-- 并行签署设置 -->
      <taskToSignLine ref="taskToSignLine" :taskId="taskId" :execId="execId" />
    </div>
    <!-- 流程图 -->
    <!-- <ImageBpm
      v-show="(isImageBpm && approvalArea) || (type=='read' || type=='request' || status=='COMMU'  || status=='FOLLOW')"
      :instId="instId"
    /> -->
  </div>
</template>
<script>
import ProcessRecord from "@/components/flow/processRecord.vue";
import ImageBpm from "@/components/flow/imageBpm.vue";
import FormContent from "@/components/flow/formContent.vue";
import OpinionText from "@/components/common/opinionText.vue";
import FileUpload from "@/components/common/fileUpload.vue";
import { mapState } from "vuex";
import { Message } from "element-ui";
import TaskToReject from "@/components/flow/task/taskToReject.vue";
import TaskToDelegate from "@/components/flow/task/taskToDelegate.vue";
import TaskToCopyTo from "@/components/flow/task/taskToCopyTo.vue";
import TaskToInqu from "@/components/flow/task/taskToInqu.vue";
import TaskToEndProcess from "@/components/flow/task/taskToEndProcess.vue";
import TaskToTrans from "@/components/flow/task/taskToTrans.vue";
import TaskToAddSign from "@/components/flow/task/taskToAddSign.vue";
import TaskToDelay from "@/components/flow/task/taskToDelay.vue";
import TaskSelectDestination from "@/components/flow/task/taskSelectDestination.vue";
import TaskSelectDestination2 from "@/components/flow/task/taskSelectDestination2.vue";
import TaskToApproveLine from "@/components/flow/task/taskToApproveLine.vue";
import taskToSignSequence from "@/components/flow/task/taskToSignSequence.vue";
import taskToSignLine from "@/components/flow/task/taskToSignLine.vue";
import utils from "@/utils.js";
import { Base64 } from "js-base64";
import moment from "moment"; //日期格式化插件
import form from "@/api/form.js";
import i18n from "@/lang/index.js";
import req from "@/request.js";

export default {
  components: {
    ImageBpm,
    ProcessRecord,
    FormContent,
    OpinionText,
    FileUpload,
    TaskToReject,
    TaskToDelegate,
    TaskToCopyTo,
    TaskToInqu,
    TaskToEndProcess,
    TaskToTrans,
    TaskToAddSign,
    TaskToDelay,
    TaskSelectDestination,
    TaskSelectDestination2,
    TaskToApproveLine,
    taskToSignSequence,
    taskToSignLine
  },
  props: [
    "tasks", //任务详情
    "task_state",
    "instId",
    "type",
    "taskId",
    "execId",
    "defId",
    "status",
    "choiceExcutor",
    "jumpType",
    "instStatus",
    "leaderId",
    "myReadType",
    "readId", //知会任务待办传阅任务的主键ID
    "readDoneId", //知会任务已办传阅任务的主键ID
    "approvalArea", //审批区域显示的内容
    "referOpinion", //允许参考意见 (选择否，则审批时不允许参考同环节其他会签人员的意见)
    "nodeType", //当前任务类型
    "nodeId", //当前任务节点
    "isNodeIdOne", //是否是用户任务1节点（即发起人节点）
    "opinionField", //要回填的字段
    "opinionFieldList", //所有任务节点的绑定的意见回填,
    "appendOpinion", //是否覆盖审批意见
    "workOrderNo" //工单号
  ],
  data() {
    return {
      btn_region_t: "96px",
      btn_region_in_w: "100%",
      btn_region_h: "66px",
      btn_region_w: "",
      isMk: false, //是否是模块开发进来
      isDd: false, //是否是只显示审批页面时
      isGdt: false, //是否有滚动条
      dialogFormVisible: false,
      dailogTitle: "",
      opinion: "",
      isHand: "",
      state: "",
      canLock: "",
      formData: "",
      actionName: "",
      text: "",
      disabled: true,
      btnAilas: "", //选择的按钮
      token: utils.getUrlKey("token"),
      isApprovalOpinion: true, //是否显示审批意见
      iszFile: true, //是否显示正文
      isFile: true, //是否显示附件
      isProcessRecord: true, //是否显示处理记录
      isImageBpm: true, //是否显示流程图
      taskStatusArray: [
        "APPROVELINEING",
        "APPROVELINEED",
        "SIGNSEQUENCEING",
        "SIGNSEQUENCEED",
        "SIGNLINEING",
        "SIGNLINEED"
      ],
      isShowMore: false,
      appendStr: true,
      initBoAttr: "",
      operation: "" //确定按钮的操作类型
    };
  },

  watch: {
    status: function(newVal, oldVal) {
      this.state = newVal; //newVal即是status
      // if (this.status == "TRANSFORMEDINQU") {
      //   this.btnAilas = "taskToInquReply";
      // } else if (this.status == "COMMU") {
      //   this.btnAilas = "commuFeedBack";
      // }
      if (
        this.state != "COPYTO" &&
        this.state != "FOLLOW" &&
        this.state != "COMMU"
      ) {
        let params = {
          taskId: this.taskId,
          leaderId: this.leaderId,
          isNodeIdOne: this.isNodeIdOne,
          nodeType: this.nodeType
        };
        //判断是否是普通用户任务加签后的待办任务
        if (this.tasks.bpmTask.parentId != "0") {
          params.isAddSign = true;
        }
        this.$store.dispatch("storeProcess/taskDetail", params); //获取操作按钮
        this.$store
          .dispatch("storeProcess/canLock", {
            taskId: this.taskId,
            leaderId: this.leaderId
          })
          .then(canLock => {
            //获取任务是否能锁定
            if (
              canLock == 4 &&
              this.$router.history.current.fullPath.indexOf("token") > -1
            ) {
              canLock = "5";
            }
            this.canLock = canLock;
          });
      }
    },
    // rowsBtn: function(newVal, oldVal) {
    //   //单选操作按钮默认选择第一个
    //   if (newVal && newVal.length > 0 && this.canLock != 1) {
    //     this.btnAilas = newVal[0].alias;
    //   }
    // },
    approvalArea: function(newVal, oldVal) {
      //审批区域显示的内容
      if (newVal) {
        this.approvalArea = newVal;
        if (this.approvalArea) {
          if (this.approvalArea.indexOf("approvalOpinion") == -1) {
            this.isApprovalOpinion = false;
          }
          if (this.approvalArea.indexOf("zFile") == -1) {
            this.iszFile = false;
          }
          if (this.approvalArea.indexOf("file") == -1) {
            this.isFile = false;
          }
          if (this.approvalArea.indexOf("processRecord") == -1) {
            this.isProcessRecord = false;
          }
          if (this.approvalArea.indexOf("imageBpm") == -1) {
            this.isImageBpm = false;
          }
        }
      }
    }
  },
  computed: mapState({
    rowsBtn: state => state.storeProcess.rowsBtn,
    isShowApprovalArea: function() {
      if (
        (this.status != "COPYTO" &&
          this.status != "FOLLOW" &&
          (this.type != undefined || this.taskId != undefined) &&
          this.instStatus != "end" &&
          this.instStatus != "manualend") ||
        this.status == "COMMU"
      ) {
        return true;
      }
      return false;
    },
    confirmBtnType: function() {
      if (this.operation == "agree" || this.operation == "taskToInquReply") {
        return "primary";
      } else {
        return "danger";
      }
    },
    isShowOperation() {
      const urlQuery = ["myRequest", "request", "myRead", "done", "read"];
      return (
        urlQuery.includes(window.location.pathname.split("/").pop()) ||
        urlQuery.includes(
          window.location.pathname
            .split("/")
            .splice(-2, 1)
            .join()
        )
      );
    }
  }),
  mounted() {
    console.log(this.opinionFieldList + "11111");
    const this_ = this;
    const loading = this.$loading({
      lock: true,
      text: "表单加载中......",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)"
    });
    //监听表单加载完成发布事件
    this_.$root.$on("formLoading", function(value) {
      this_.disabled = value;
      setTimeout(() => {
        this_.$set(
          this_,
          "btn_region_w",
          document.getElementById("display_none").offsetWidth
        );
        loading.close();
      }, 500);
    });
    if (this.type == "request" || this.type == "read") {
      if (this.$refs.btnRegion) {
        this.$refs.btnRegion.style.display = "none";
      }
      this.$refs.formContent.hiddenContent();
    }
    // //单选操作按钮默认选择第一个
    // if (this.type == "done" || this.type == "request") {
    //   this.btnAilas = "handleRevoke";
    // } else if (this.type == "read") {
    //   this.btnAilas = "handleRead";
    // } else {
    //   if (this.rowsBtn.length > 0 && this.canLock != 1) {
    //     this.btnAilas = this.rowsBtn[0].alias;
    //   }
    // }
  },
  methods: {
    //执行前置脚本
    tempScript(script) {
      let _this = this;
      let _req = req;
      let boData = _this.$refs.formContent.data;
      var script =
        "var tempFunction = function(_req,data,_this){ " + script + "};";
      var result = eval(script + "tempFunction(_req,boData,_this);");
      if (result && result.then && typeof result.then == "function") {
        return result;
      }
      if (result === false) return false;
      return true;
    },

    //获取意见
    async getOpinion(opinion) {
      this.text = opinion;
      let opinioValue = this.$refs.opinionText.getOpinion();
      if (this.opinionField) {
        let currentUser = this.$store.state.user.currentUserDetail.user;
        let boData = this.$refs.formContent.data;
        let filed = this.opinionField.split(".");
        if (boData[filed[0]][filed[1]] == "<p><br/></p>") {
          boData[filed[0]][filed[1]] = "";
        }
        let currentTime = "";
        /** 20220908*/
        const result = await this.$http.get(
          "${bpmModel}/flow/approvalItem/v1/getApprovalTime"
        );
        currentTime = result.data.message;
        //是否覆盖审批意见
        if (this.appendOpinion) {
          if (opinioValue) {
            boData[filed[0]][filed[1]] =
              opinioValue +
              "<br/><br/>" +
              currentUser.fullname +
              " " +
              currentTime;
          }
        } else {
          if (opinioValue) {
            opinioValue +=
              "<br/><br/>" + currentUser.fullname + " " + currentTime;
          }
          if (this.appendStr) {
            this.initBoAttr = boData[filed[0]][filed[1]];
          }
          if (filed.length == 2) {
            if (this.initBoAttr) {
              if (opinion) {
                boData[filed[0]][filed[1]] =
                  this.initBoAttr + "<br/><br/>" + opinioValue;
              } else {
                boData[filed[0]][filed[1]] = this.initBoAttr;
              }
            } else {
              boData[filed[0]][filed[1]] = opinioValue;
            }
          }
          this.appendStr = false;
        }
        /*else if (filed.length==3 &&boData[filed[0]][filed[1]].length>0){//处理子表
          for (let i = 0; i <boData[filed[0]][filed[1]].length ; i++) {
            boData[filed[0]][filed[1]][i][filed[2]]=opinioValue;
          }
        }*/
      }
    },
    //保存按钮
    saveDraftBtn() {
      this.$store
        .dispatch("storeProcess/canLock", {
          taskId: this.taskId,
          leaderId: this.leaderId
        })
        .then(canLock => {
          //获取任务是否能锁定
          if (
            canLock == 4 &&
            this.$router.history.current.fullPath.indexOf("token") > -1
          ) {
            canLock = "5";
          }
          if (canLock == 4) {
            this.$message.warning("任务已被其他人签收了");
          } else {
            this.taskSaveDraft();
          }
        });
    },
    //同意按钮
    agreeBtn() {
      let opinioValue = this.$refs.opinionText.getOpinion();
      //清空意见
      if (!opinioValue) {
        /*this.$emit("textOpinion", "同意");
          this.getOpinion("同意");*/
        this.$message({ type: "warning", message: "请输入意见" });
        if (!this.isShowMore) {
          this.showMoreOperations();
        }
      }
      this.$store
        .dispatch("storeProcess/canLock", {
          taskId: this.taskId,
          leaderId: this.leaderId
        })
        .then(canLock => {
          //获取任务是否能锁定
          if (
            canLock == 4 &&
            this.$router.history.current.fullPath.indexOf("token") > -1
          ) {
            canLock = "5";
          }
          if (canLock == 4) {
            this.$message.warning("任务已被其他人签收了");
          } else {
            this.taskAgree();
          }
        });
    },
    checkInstStatus(callback) {
      let this_ = this;
      this.$http
        .get(
          "${bpmRunTime}/runtime/instance/v1/getDefStatus?instId=" +
            (this.instId || "") +
            "&taskId=" +
            (this.taskId || "")
        )
        .then(function(resp) {
          if (resp.data) {
            resp.data += "";
            if (resp.data.indexOf("1") > -1) {
              this_.disabled = true;
              this_.$message.warning("当前流程实例已被挂起，无法审批");
            } else if (resp.data.indexOf("3") > -1) {
              this_.disabled = true;
              this_.$message.warning("当前流程定义已被禁止实例，无法审批");
            } else {
              callback();
            }
          } else if (callback) {
            callback();
          }
        });
    },
    //提交事件
    submitRevoke(ailas) {
      if (!this.disabled) {
        this.disabled = true;
        setTimeout(() => {
          this.disabled = false;
        }, 500);
      }
      this.btnAilas = ailas;

      // <p><br/></p> 处理
      let boData = this.$refs.formContent.data;
      if (boData) {
        for (let key in boData) {
          if (boData[key]) {
            for (let subKey in boData[key]) {
              if (boData[key][subKey] === "<p><br/></p>") {
                boData[key][subKey] = "";
              }
            }
          }
        }
      }
      if (this.btnAilas == "taskClose") {
        //关闭
        /*if (this.type == "done" || this.type == "request") {
          this.$router.push("/v-flow/v-request");
        } else {
          if (JSON.stringify(this.$route.query) == "{}") {
            this.$router.go(-1);
          } else {
            this.$router.push("/home");
          }
        }*/
        window.close();
      } else if (this.btnAilas == "saveDraft") {
        //保存
        let _this = this;
        _this.$refs.opinionText.opinion = "";
        let item = utils.indexOfList(_this.rowsBtn, "alias", _this.btnAilas);
        let beforeScript = item.beforeScript; //前置脚本
        let scriptResult = this.tempScript(beforeScript);
        //执行前置脚本返回false时终止按钮操作
        if (scriptResult === false) return;
        //执行前置脚本返回的接口时先执行前置事件接口
        if (scriptResult.then && typeof scriptResult.then == "function") {
          scriptResult.then(
            function(success) {
              //接口返回成功则正常执行按钮操作
              _this.saveDraftBtn();
            },
            function(fail) {
              //接口返回失败则终止按钮操作，并给与提示
              _this.$message.warning(fail);
              return;
            }
          );
        } else {
          //执行前置脚本返回true时正常执行按钮操作
          _this.saveDraftBtn();
        }
      } else if (this.btnAilas == "agree") {
        //同意
        let opinion = this.$refs.opinionText.getOpinion();
        if (!opinion) {
          this.$message({ type: "warning", message: "请输入同意意见" });
          if (!this.isShowMore) {
            this.showMoreOperations();
          }
          this.operation = "agree";
          return;
        } else {
          if (this.operation != "agree") {
            this.getOpinion("");
            this.$message({ type: "warning", message: "请重新输入同意意见" });
            this.operation = "agree";
            return;
          }
        }
        let _this = this;
        let item = utils.indexOfList(_this.rowsBtn, "alias", _this.btnAilas);
        let beforeScript = item.beforeScript; //前置脚本
        let scriptResult = this.tempScript(beforeScript);
        //执行前置脚本返回false时终止按钮操作
        if (scriptResult === false) return;
        //执行前置脚本返回的接口时先执行前置事件接口
        if (scriptResult.then && typeof scriptResult.then == "function") {
          scriptResult.then(
            function(success) {
              //接口返回成功则正常执行按钮操作
              _this.agreeBtn();
            },
            function(fail) {
              //接口返回失败则终止按钮操作，并给与提示
              _this.$message.warning(fail);
              return;
            }
          );
        } else {
          //执行前置脚本返回true时正常执行按钮操作
          _this.agreeBtn();
        }
      } else if (this.btnAilas == "free") {
        //自动流转
        this.doNext();
      } else if (this.btnAilas == "handleRead") {
        //传阅回复
        this.handleRead();
      } else if (this.btnAilas == "handleRevoke") {
        //撤回
        this.handleRevoke();
      } else if (this.btnAilas == "commuFeedBack") {
        //沟通反馈
        this.commuFeedBack();
      } else if (this.btnAilas == "taskToInquReply") {
        //征询回复
        this.taskToInquReply();
      } else if (this.btnAilas == "reject") {
        //驳回
        let _this = this;
        let opinion = this.$refs.opinionText.getOpinion();
        if (!opinion) {
          if (!this.isShowMore) {
            this.showMoreOperations();
          }
          this.$message({ type: "warning", message: "请输入驳回意见" });
          this.operation = "reject";
          return;
        } else {
          if (this.operation != "reject") {
            this.getOpinion("");
            this.$message({ type: "warning", message: "请重新输入驳回意见" });
            this.operation = "reject";
            return;
          }
        }
        let item = utils.indexOfList(_this.rowsBtn, "alias", _this.btnAilas);
        let beforeScript = item.beforeScript; //前置脚本
        let scriptResult = this.tempScript(beforeScript);
        //执行前置脚本返回false时终止按钮操作
        if (scriptResult === false) return;
        //执行前置脚本返回的接口时先执行前置事件接口
        if (scriptResult.then && typeof scriptResult.then == "function") {
          scriptResult.then(
            function(success) {
              //接口返回成功则正常执行按钮操作
              this.taskToReject();
            },
            function(fail) {
              //接口返回失败则终止按钮操作，并给与提示
              _this.$message.warning(fail);
              return;
            }
          );
        } else {
          //执行前置脚本返回true时正常执行按钮操作
          this.taskToReject();
        }
      } else if (this.btnAilas == "delegate") {
        //转办
        this.taskToDelegate();
      } else if (this.btnAilas == "inqu") {
        //征询
        this.taskToInqu();
      } else if (this.btnAilas == "endProcess") {
        //流程终止
        let _this = this;
        let item = utils.indexOfList(_this.rowsBtn, "alias", _this.btnAilas);
        let beforeScript = item.beforeScript; //前置脚本
        let scriptResult = this.tempScript(beforeScript);
        //执行前置脚本返回false时终止按钮操作
        if (scriptResult === false) return;
        //执行前置脚本返回的接口时先执行前置事件接口
        if (scriptResult.then && typeof scriptResult.then == "function") {
          scriptResult.then(
            function(success) {
              //接口返回成功则正常执行按钮操作
              this.taskToEndProcess();
            },
            function(fail) {
              //接口返回失败则终止按钮操作，并给与提示
              _this.$message.warning(fail);
              return;
            }
          );
        } else {
          //执行前置脚本返回true时正常执行按钮操作
          this.taskToEndProcess();
        }
      } else if (this.btnAilas == "startTrans") {
        //流转
        let _this = this;
        let item = utils.indexOfList(_this.rowsBtn, "alias", _this.btnAilas);
        let beforeScript = item.beforeScript; //前置脚本
        let scriptResult = this.tempScript(beforeScript);
        //执行前置脚本返回false时终止按钮操作
        if (scriptResult === false) return;
        //执行前置脚本返回的接口时先执行前置事件接口
        if (scriptResult.then && typeof scriptResult.then == "function") {
          scriptResult.then(
            function(success) {
              //接口返回成功则正常执行按钮操作
              this.taskToTrans();
            },
            function(fail) {
              //接口返回失败则终止按钮操作，并给与提示
              _this.$message.warning(fail);
              return;
            }
          );
        } else {
          //执行前置脚本返回true时正常执行按钮操作
          this.taskToTrans();
        }
      } else if (this.btnAilas == "addSign" || this.btnAilas == "addSignMore") {
        //加签
        let item = utils.indexOfList(this.rowsBtn, "alias", this.btnAilas);
        let _this = this;
        let beforeScript = item.beforeScript; //前置脚本
        let scriptResult = this.tempScript(beforeScript);
        //执行前置脚本返回false时终止按钮操作
        if (scriptResult === false) return;
        //执行前置脚本返回的接口时先执行前置事件接口
        if (scriptResult.then && typeof scriptResult.then == "function") {
          scriptResult.then(
            function(success) {
              //接口返回成功则正常执行按钮操作
              this.taskToAddSign();
            },
            function(fail) {
              //接口返回失败则终止按钮操作，并给与提示
              _this.$message.warning(fail);
              return;
            }
          );
        } else {
          //执行前置脚本返回true时正常执行按钮操作
          this.taskToAddSign();
        }
      } else if (this.btnAilas == "taskDelay") {
        //任务延期
        let _this = this;
        let item = utils.indexOfList(_this.rowsBtn, "alias", _this.btnAilas);
        let beforeScript = item.beforeScript; //前置脚本
        let scriptResult = this.tempScript(beforeScript);
        //执行前置脚本返回false时终止按钮操作
        if (scriptResult === false) return;
        //执行前置脚本返回的接口时先执行前置事件接口
        if (scriptResult.then && typeof scriptResult.then == "function") {
          scriptResult.then(
            function(success) {
              //接口返回成功则正常执行按钮操作
              this.taskToDelay();
            },
            function(fail) {
              //接口返回失败则终止按钮操作，并给与提示
              _this.$message.warning(fail);
              return;
            }
          );
        } else {
          //执行前置脚本返回true时正常执行按钮操作
          this.taskToDelay();
        }
      } else if (this.btnAilas == "agreeTrans") {
        //同意（流转）
        let _this = this;
        let item = utils.indexOfList(_this.rowsBtn, "alias", _this.btnAilas);
        let beforeScript = item.beforeScript; //前置脚本
        let scriptResult = this.tempScript(beforeScript);
        //执行前置脚本返回false时终止按钮操作
        if (scriptResult === false) return;
        //执行前置脚本返回的接口时先执行前置事件接口
        if (scriptResult.then && typeof scriptResult.then == "function") {
          scriptResult.then(
            function(success) {
              //接口返回成功则正常执行按钮操作
              this.taskAgreeTrans();
            },
            function(fail) {
              //接口返回失败则终止按钮操作，并给与提示
              _this.$message.warning(fail);
              return;
            }
          );
        } else {
          //执行前置脚本返回true时正常执行按钮操作
          this.taskAgreeTrans();
        }
      } else if (this.btnAilas == "opposeTrans") {
        //反对（流转）
        let _this = this;
        let item = utils.indexOfList(_this.rowsBtn, "alias", _this.btnAilas);
        let beforeScript = item.beforeScript; //前置脚本
        let scriptResult = this.tempScript(beforeScript);
        //执行前置脚本返回false时终止按钮操作
        if (scriptResult === false) return;
        //执行前置脚本返回的接口时先执行前置事件接口
        if (scriptResult.then && typeof scriptResult.then == "function") {
          scriptResult.then(
            function(success) {
              //接口返回成功则正常执行按钮操作
              this.taskOpposeTrans();
            },
            function(fail) {
              //接口返回失败则终止按钮操作，并给与提示
              _this.$message.warning(fail);
              return;
            }
          );
        } else {
          //执行前置脚本返回true时正常执行按钮操作
          this.taskOpposeTrans();
        }
      } else if (this.btnAilas == "oppose") {
        //反对
        let _this = this;
        let opinion = this.$refs.opinionText.getOpinion();
        if (!opinion) {
          if (!this.isShowMore) {
            this.showMoreOperations();
          }
          this.$message({ type: "warning", message: "请输入反对意见" });
          this.operation = "oppose";
          return;
        } else {
          if (_this.operation != "oppose") {
            this.$message({ type: "warning", message: "请重新输入反对意见" });
            this.getOpinion("");
            this.operation = "oppose";
            return;
          }
        }
        let item = utils.indexOfList(_this.rowsBtn, "alias", _this.btnAilas);
        let beforeScript = item.beforeScript; //前置脚本
        let scriptResult = this.tempScript(beforeScript);
        //执行前置脚本返回false时终止按钮操作
        if (scriptResult === false) return;
        //执行前置脚本返回的接口时先执行前置事件接口
        if (scriptResult.then && typeof scriptResult.then == "function") {
          scriptResult.then(
            function(success) {
              //接口返回成功则正常执行按钮操作
              this.taskOppose();
            },
            function(fail) {
              //接口返回失败则终止按钮操作，并给与提示
              _this.$message.warning(fail);
              return;
            }
          );
        } else {
          //执行前置脚本返回true时正常执行按钮操作
          this.taskOppose();
        }
      } else if (this.btnAilas == "lockUnlock") {
        //签收
        this.$store
          .dispatch("storeProcess/canLock", this.taskId)
          .then(canLock => {
            //获取任务是否能锁定
            if (
              canLock == 4 &&
              this.$router.history.current.fullPath.indexOf("token") > -1
            ) {
              canLock = "5";
            }
            if (canLock == 4) {
              this.$message.warning("任务已被其他人签收了");
            } else {
              this.lockUnlock();
            }
          });
      } else if (this.btnAilas == "approveLine") {
        //并行审批
        this.taskApproveLine();
      } else if (this.btnAilas == "signSequence") {
        // 顺序签署
        this.taskSignSequence();
      } else if (this.btnAilas == "signLine") {
        // 并行签署
        this.taskSignLine();
      }
    },
    //确定按钮
    confirmBtn() {
      this.disabled = true;
      setTimeout(() => {
        this.disabled = false;
      }, 500);
      if (this.operation == "agree") {
        this.submitRevoke("agree");
        return;
      }
      if (this.operation == "reject") {
        this.submitRevoke("reject");
        return;
      }
      if (this.operation == "oppose") {
        this.submitRevoke("oppose");
        return;
      }
      if (this.operation == "taskToInquReply") {
        this.submitRevoke("taskToInquReply");
        return;
      }
    },
    //保存
    taskSaveDraft() {
      //不保存意见
      this.$refs.opinionText.opinion = "";
      utils.getOnlineFormData(false).then(formDataStr => {
          let data = this.handleFormData(formDataStr);
          data.defId = this.defId;
          data.approval = true;
          this.$store.dispatch("storeProcess/saveTaskDraft", data).then(() => {
            // utils.reload();20220907
            window.location.reload();
          });
        }).catch(reason => utils.handleGetFormDataReject(reason));
    },
    //传阅回复
    handleRead() {
      if (this.$refs.opinionText.getOpinion() == "") {
        Message.warning("请输入回复意见");
      } else {
        let files = "";
        let zfiles = "";
        this.$refs.fileUpload.isFinishUpload();

        //this.$refs.zfileUpload.isFinishUpload();

        //if (this.$refs.zfileUpload && this.$refs.zfileUpload.getFiles() != "") {
        //zfiles = JSON.stringify(this.$refs.zfileUpload.getFiles());
        //}
        if (this.$refs.fileUpload && this.$refs.fileUpload.getFiles() != "") {
          files = JSON.stringify(this.$refs.fileUpload.getFiles());
        }
        let data = {
          instId: this.instId,
          taskId: this.taskId,
          opinion: this.$refs.opinionText.getOpinion(),
          files: files,
          zfiles: zfiles
        };
        this.$store.dispatch("storeProcess/doNextCopyto", data).then(() => {
          // if (this.token != null) {
          this.windowClose();
          // } else {
          //   this.$router.go(-1);
          // }
        });
      }
    },
    windowClose() {
      if (window.ch) {
        //浏览器的两个选项卡之间通讯 新窗口发送消息
        window.ch.postMessage("some data");
      }
      window.close();
    },
    // 准备要提交的数据
    handleFormData(formDataStr) {
      let files = "";
      let zfiles = "";
      this.$refs.fileUpload.isFinishUpload();
      //this.$refs.zfileUpload.isFinishUpload();

      //if (this.$refs.zfileUpload && this.$refs.zfileUpload.getFiles() != "") {
      //zfiles = JSON.stringify(this.$refs.zfileUpload.getFiles());
      //}
      if (this.$refs.fileUpload && this.$refs.fileUpload.getFiles() != "") {
        files = JSON.stringify(this.$refs.fileUpload.getFiles());
      }
      let opinion = "";
      if (this.$refs.opinionText && this.$refs.opinionText.getOpinion() != "") {
        opinion = this.$refs.opinionText.getOpinion();
      }

      let data = {
        taskId: this.taskId,
        actionName: this.actionName,
        destination: "",
        files: files,
        zfiles: zfiles,
        opinion: opinion,
        jumpType: "",
        agentLeaderId: this.leaderId,
        nodeUsers: "[]"
      };
      if (formDataStr) {
        // URL表单
        if (formDataStr.constructor == Object) {
          data.formType = "frame";
          if (formDataStr.businessKey) {
            data.businessKey = formDataStr.businessKey;
          }
          if (formDataStr.sysCode) {
            data.sysCode = formDataStr.sysCode;
          }
          if (formDataStr.vars) {
            data.vars = formDataStr.vars;
          }
        } else if (formDataStr.constructor == String) {
          data.data = Base64.encode(formDataStr);
          data.formType = "inner";
        }
      }

      if (window.urgentStateValue) {
        data.urgentStateValue = window.urgentStateValue;
      }

      return data;
    },
    handleClose() {
      this.dialogFormVisible = true;
    },
    //获取任务锁定状态
    lockUnlock() {
      this.$store
        .dispatch(
          "storeProcess/lockUnlock", this.$refs.opinionText.getOpinion(),
          this.taskId + "&leaderId=" + this.leaderId
        )
        .then(() => {
          // this.$router.go(this.$router.currentRoute);
          utils.reload();
        });
    },
    //撤回
    handleRevoke(id, status) {
      if (status == "revokeToStart") {
        this.$message.warning("已撤回，不能再撤回");
        return false;
      }
      if (this.$refs.opinionText.getOpinion() == "") {
        this.$message.warning("请填写撤回意见");
        return false;
      }
      let data = {
        instanceId: this.instId,
        isHandRevoke: this.isHand,
        cause: this.$refs.opinionText.getOpinion()
      };
      this.$confirm("确认" + this.dailogTitle + "?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
        closeOnClickModal: false
      }).then(() => {
        this.$store
          .dispatch("storeProcess/revokeInstanceBtn", data)
          .then(isHandRevoke => {
            // if (this.token != null) {
            this.windowClose();
            // } else {
            //   this.$router.push("/v-flow/v-todo");
            // }
          });
      });
    },
    saveRevoke() {
      if (this.opinion == "") {
        this.$message.warning("请填写撤回意见");
        return false;
      }
      let data = {
        instanceId: this.instId,
        isHandRevoke: this.isHand,
        cause: this.opinion
      };
      this.$store.dispatch("storeProcess/revokeInstanceBtn", data).then(() => {
        // if (this.token != null) {
        this.windowClose();
        // } else {
        //   this.$router.go(-1);
        // }
      });
      this.dialogFormVisible = false;
      this.opinion = "";
    },
    exitRevoke() {
      this.dialogFormVisible = false;
      this.opinion = "";
    },
    //沟通反馈
    commuFeedBack() {
      if (!this.isShowMore) {
        this.showMoreOperations();
      }
      if (this.$refs.opinionText.getOpinion() == "") {
        Message.warning("请输入意见内容");
      } else {
        let files = "";
        let zfiles = "";
        this.$refs.fileUpload.isFinishUpload();
        //this.$refs.zfileUpload.isFinishUpload();

        //if (this.$refs.zfileUpload && this.$refs.zfileUpload.getFiles() != "") {
        //  zfiles = JSON.stringify(this.$refs.zfileUpload.getFiles());
        //}
        if (this.$refs.fileUpload && this.$refs.fileUpload.getFiles() != "") {
          files = JSON.stringify(this.$refs.fileUpload.getFiles());
        }
        let data = {
          instId: this.instId,
          taskId: this.taskId,
          opinion: this.$refs.opinionText.getOpinion(),
          files: files,
          zfiles: zfiles
        };
        this.$store.dispatch("storeProcess/doNextcommu", data).then(() => {
          // if (this.token != null) {
          this.windowClose();
          // } else {
          //   this.$router.go(-1);
          // }
        });
      }
    },
    //征询回复
    taskToInquReply() {
      if (!this.isShowMore) {
        this.showMoreOperations();
      }
      if (this.$refs.opinionText.getOpinion() == "") {
        Message.warning("请输入意见内容");
        this.operation = "taskToInquReply";
      } else {
        let files = "";
        let zfiles = "";
        this.$refs.fileUpload.isFinishUpload();
        //this.$refs.zfileUpload.isFinishUpload();

        //if (this.$refs.zfileUpload && this.$refs.zfileUpload.getFiles() != "") {
        //  zfiles = JSON.stringify(this.$refs.zfileUpload.getFiles());
        //}
        if (this.$refs.fileUpload && this.$refs.fileUpload.getFiles() != "") {
          files = JSON.stringify(this.$refs.fileUpload.getFiles());
        }
        let data = {
          procDefId: this.defId,
          procInstId: this.instId,
          status: "inqu_reply",
          taskId: this.taskId,
          opinion: this.$refs.opinionText.getOpinion(),
          files: files,
          zfiles: zfiles,
          formData: JSON.stringify(this.$refs.formContent.data)
        };
        this.$store.dispatch("storeProcess/taskToInquReply", data).then(() => {
          // if (this.token != null) {
          this.windowClose();
          // } else {
          //   this.$router.go(-1);
          // }
        });
      }
    },
    //驳回设置
    taskToReject() {
      if (this.$refs.opinionText.getOpinion() == "") {
        this.$set(this, "btn_region_h", "185px");
        if (!this.isDd) {
          this.$refs.formContent.updateStyle("220px");
        } else if (this.isDd) {
          this.$refs.formContent.updateStyle("267px");
        }
        this.isShowMore = true;
        //重新给操作区域宽度赋值
        setTimeout(() => {
          this.$set(
            this,
            "btn_region_w",
            document.getElementById("display_none").offsetWidth
          );
        }, 10);
        Message.warning("请填写驳回审批意见");
        return;
      }
      let parentTaskId = ""; //用户任务加签后的父任务ID
      if (this.nodeType == "USERTASK" && this.tasks.bpmTask.parentId != "0") {
        //用户任务加签
        parentTaskId = this.tasks.bpmTask.parentId;
      }
      this.$refs.taskToReject.handleOpen(parentTaskId); //父组件调用子组件方法
    },
    //转办设置
    taskToDelegate() {
      this.$refs.taskToDelegate.handleClose(
        this.opinionField,
        this.$refs.formContent.data,
        this.appendOpinion
      ); //父组件调用子组件方法
    },
    // //流程抄送
    // taskToCopyTo() {
    //   this.$refs.taskToCopyTo.handleClose(); //父组件调用子组件方法
    // },
    //征询设置
    taskToInqu() {
      this.$refs.taskToInqu.handleClose(
        this.opinionField,
        this.$refs.formContent.data,
        this.appendOpinion
      ); //父组件调用子组件方法
    },
    //流程终止
    taskToEndProcess() {
      this.$refs.taskToEndProcess.handleClose(); //父组件调用子组件方法
    },
    //流转设置
    taskToTrans() {
      this.$refs.taskToTrans.handleClose(); //父组件调用子组件方法
    },
    //加签设置
    taskToAddSign() {
      this.$refs.taskToAddSign.handleClose(this.nodeType, this.instId); //父组件调用子组件方法
    },
    //任务延期
    taskToDelay() {
      this.$refs.taskToDelay.handleClose(); //父组件调用子组件方法
    },
    //并行审批
    taskApproveLine() {
      this.$refs.taskToApproveLine.handleClose(); //父组件调用子组件方法
    },
    // 顺序签署
    taskSignSequence() {
      this.$refs.taskToSignSequence.handleClose(); //父组件调用子组件方法
    },
    // 并行签署
    taskSignLine() {
      this.$refs.taskToSignLine.handleClose(); //父组件调用子组件方法
    },
    doNext() {
      const this_ = this;
      utils
        .getOnlineFormData(true)
        .then(formDataStr => this_.doNextSubmit(formDataStr))
        .catch(reason =>
          utils
            .handleGetFormDataReject(reason)
            .then(() => this_.doNextSubmit())
            .catch()
        );
    },
    // doNext执行。formDataStr：字符串格式的表单数据。确认提交
  doNextSubmit(formDataStr) {
      let data = this.handleFormData(formDataStr);
      data.formKey = this.$refs.formContent.formKey;
      if (!data.opinion) {
        if (this.actionName == "opposeTrans" || this.actionName == "oppose") {
          this.$message.warning("请输入反对意见");
          this.operation = "oppose";
          if (!this.isShowMore) {
            this.showMoreOperations();
          }
          return;
        }
        data.opinion = this.text = "同意";
      }
      if (this.nodeType == "USERTASK" && this.tasks.bpmTask.parentId != "0") {
        //用户任务加签
        if (this.actionName == "oppose") {
          data.addSignAction = "opposeTrans";
        } else if (this.actionName == "agree") {
          data.addSignAction = "agreeTrans";
        }
      }
      if (
        (this.choiceExcutor ||
          this.jumpType ||
          this.$route.query.type === "free") &&
        this.instStatus != "back" &&
        this.instStatus != "backToStart" &&
        !this.taskStatusArray.includes(this.status)
      ) {
        if (this.$route.query.type === "free" && this.btnAilas == "free") {
          this.$refs.taskSelectDestination2.showDialog(
            data.data,
            data.files,
            data.zfiles,
            this.instId,
            this.jumpType,
            true,
            this.opinionField,
            this.$refs.formContent.data,
            this.appendOpinion,
            data,
            this
          );
          return;
        }
        this.$store
          .dispatch("storeProcess/getAfterJumpNodes", {
            taskId: this.taskId,
            data: data.data,
            defId: "",
            instId: ""
          })
          .then(res => {
            if (
              res.afterNodes.length == 0 ||
              (res.afterNodes.length == 1 &&
                res.afterNodes[0].excutorList != undefined &&
                res.afterNodes[0].excutorList.length == 1)
            ) {
              this.disabled = true;
              this.$confirm("确认办理此任务?", "提示", {
                cancelButtonText: "取消",
                confirmButtonText: "确定",
                type: "warning",
                closeOnClickModal: false
              })
                .then(() => {
                  this.$store
                    .dispatch("storeProcess/complete", data)
                    .then(() => {
                      this.windowClose();
                      //this.$router.push("/inst/" + this.instId + "/doneList");
                    });
                })
                .finally(() => {
                  this.disabled = false;
                });
            } else {
              this.$refs.taskSelectDestination.showDailog(
                data.data,
                data.files,
                data.zfiles,
                data.opinion,
                this.instId
              );
            }
          });
      } else {
        this.disabled = true;
        let tipMsg = "确认办理此任务?";
        if (this.actionName == "agree" && this.status == "SIGNSEQUENCEED") {
          this.$http
            .get(
              "${bpmRunTime}/runtime/task/v1/nextExecutor?taskId=" + this.taskId
            )
            .then(response => {
              if (response.data.state && response.data.value) {
                tipMsg = `下一步的执行人为：${
                  response.data.value.name
                }。<br/> 您确定要提交吗？`;
              }
              this.$confirm(tipMsg, "提示", {
                cancelButtonText: "取消",
                confirmButtonText: "确定",
                type: "warning",
                closeOnClickModal: false,
                dangerouslyUseHTMLString: true
              })
                .then(() => {
                  this.$store
                    .dispatch("storeProcess/complete", data)
                    .then(() => {
                      this.windowClose();
                      // this.$router.push("/inst/" + this.instId + "/doneList");
                    });
                })
                .finally(() => {
                  this.disabled = false;
                });
            });
          return;
        }
        this.$confirm("确认办理此任务?", "提示", {//确认时调用
          cancelButtonText: "取消",
          confirmButtonText: "确定",
          type: "warning",
          closeOnClickModal: false
        }).then(async () => {
            
        /*let opinioValue = this.$refs.opinionText.getOpinion();
        let currentUser = this.$store.state.user.currentUserDetail.user;

        let boData = this.$refs.formContent.data;
        let filed = this.opinionField.split(".");
        debugger;
        if (boData[filed[0]] == "<p><br/></p>") {
          boData[filed[0]] = "";
        }
        let currentTime = "";
        //20220908
        const result = await this.$http.get(
          "${bpmModel}/flow/approvalItem/v1/getApprovalTime"
        );
        currentTime = result.data.message;
        //是否覆盖审批意见
        if (this.appendOpinion) {
          if (opinioValue) {
            boData[filed[0]] =
              opinioValue +
              "<br/><br/>" +
              currentUser.fullname +
              " " +
              currentTime;
          }
        } else {
          if (opinioValue) {
            opinioValue +=
              "<br/><br/>" + currentUser.fullname + " " + currentTime;
          }
          if (this.appendStr) {
            this.initBoAttr = boData[filed[0]];
          }
          if (filed.length == 2) {
            if (this.initBoAttr) {
              if (opinion) {
                boData[filed[0]] =
                  this.initBoAttr + "<br/><br/>" + opinioValue;
              } else {
                boData[filed[0]] = this.initBoAttr;
              }
            } else {
              boData[filed[0]] = opinioValue;
            }
          }
        }
        data.data = Base64.encode(JSON.stringify(boData));*/
        this.$store.dispatch("storeProcess/complete", data).then(() => {
          this.windowClose();
            //this.$router.push("/inst/" + this.instId + "/doneList");
        });
      }).finally(() => {
          //this.disabled = false;
        });
      }
    },
    //同意
    taskAgree() {
      this.actionName = "agree";
      this.doNext();
    },
    //同意（流转）
    taskAgreeTrans() {
      this.actionName = "agreeTrans";
      this.doNext();
    },
    //反对
    taskOppose() {
      this.actionName = "oppose";
      this.doNext();
    },
    //反对（流转）
    taskOpposeTrans() {
      this.actionName = "opposeTrans";
      this.doNext();
    },
    hiddenOpertion() {
      if (this.$refs.btnRegion) {
        this.$refs.btnRegion.style.display = "none";
      }
      this.$refs.formContent.hiddenContent();
    },
    //是否显示滚动条
    isScroll() {
      //屏幕宽度
      let window_width = $(window).width();
      //审批页面宽度
      let from_w = $("main")[0].clientWidth;
      //有滚动条
      if (window_width > from_w) {
        return true;
      }
      return false;
    },
    //更多操作 只修改了css样式 无业务相关操作
    showMoreOperations() {
      if (this.isShowMore) {
        this.$set(this, "btn_region_h", "66px");
        this.isShowMore = false;
        if (!this.isDd) {
          //是否是只显示审批页面
          this.$refs.formContent.updateStyle("99px");
        } else if (this.isDd) {
          this.$refs.formContent.updateStyle("119px");
        }
      } else {
        this.$set(this, "btn_region_h", "185px");
        this.isShowMore = true;
        if (!this.isDd) {
          //是否是只显示审批页面
          this.$refs.formContent.updateStyle("220px");
        } else if (this.isDd) {
          this.$refs.formContent.updateStyle("267px");
        }
      }
      //重新给操作区域宽度赋值
      setTimeout(() => {
        this.$set(
          this,
          "btn_region_w",
          document.getElementById("display_none").offsetWidth
        );
      }, 10);
    }
  },
  created() {

    const this_ = this;
    //监听审批意见控件值改变发布事件
    this.$root.$on("textOpinion", function(value) {
      this_.text = value;
    });
    //兼容只显示审批页面时
    if (this.$route.meta.single) {
      this.isDd = true;
      this.btn_region_t = "40px";
      this.btn_region_in_w = "100%";
      this.btn_region_w = "100%";
      setTimeout(() => {
        this.$refs.formContent.updateStyle("119px");
      }, 10);
    }
    this.checkInstStatus();
    if (this.type == "done") {
      this.dailogTitle = "撤回";
      this.isHand = true;
    } else if (this.type == "request") {
      this.dailogTitle = "撤回到发起人";
      this.isHand = false;
    }
    if (this.type == "request") {
      this.isProcessRecord = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";



@media (max-width: 1920px) {
  /deep/ .no-print{
    top: 6% !important;
    width: 100% !important;
    background: #666;
  }
}
@media (max-width:1440px) {
  /deep/ .no-print{
    top: 7% !important;
    width: 100% !important;
    background: #666;
  }
}

@media (max-width:1366px) {
  /deep/ .no-print{
    top: 8% !important;
    width: 100% !important;
    background: #666;
  }
}

@media (max-width:1360px) {
  /deep/ .no-print{
    top: 8% !important;
    width: 100% !important;
    background: #666;
  }
}

@media (max-width:1280px) {
  /deep/ .no-print{
    top: 6% !important;
    width: 100% !important;
    background: #666;
  }
}

.action-container {
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 10px;
}

.action-container > span {
  border-left: 3px solid $--theme-color;
  font-weight: bold;
  font-size: 14px;
  padding-left: 10px;
  color: #666;
}

.action-content {
  padding: 20px 0;
}

.action-group {
  padding-top: 1px;
}

.action-btn {
  float: left;
  padding-right: 5px;
}

.btn_region {
  position: fixed;
  background: #f5f5f5;
  z-index: 99;
  margin-top: -26px;
  padding-top: 0px;
}
@media (max-width: 1024px) {
  .btn_region {
    width: 94.4% !important;
  }
}
.btn-wrap {
  height: 50px;
}
.is-showmore__height {
  height: 158px;
}
// .btn_region_in {
//   background-color: #fff;
// }

.region {
  padding-top: 10px;
}
.showmore__content {
}
.is-showbtn__height {
  height: 190px;
}
</style>
